import { useContext } from 'react';
import Context from './Context';

export default function useAuthApi() {
  const { auth } = useContext(Context);
  return auth;
}
